<template>
    <div class="page-channel page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">{{channel_name}} - 商品管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>商品管理</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '/join/channel' }">频道管理</el-breadcrumb-item>
                            <el-breadcrumb-item>{{channel_name}} - 商品管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-o" @click="handleChannelGoods()">添加推荐商品 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量取消</el-button>
                    <el-button type="primary" class="btn-bg-p" @click="knockmultiple()">批量立减</el-button>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <!--<el-form-item prop="id" label="ID：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.id" size="small" placeholder="频道ID" clearable></el-input>
                        </el-form-item>-->
                        <el-form-item prop="name" label="商品名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="商品名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="status" label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  prop="week" label="推荐时间：">
                            <el-select size="small" v-model="form_search.week" placeholder="请选择">
                                <el-option
                                        v-for="item in init_data.week_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                            <el-table-column prop="name" align="center" label="商品名称" min-width="160">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.name"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="channel_name" align="center" label="所属频道" min-width="120">
                            </el-table-column>
                            <el-table-column prop="week_name" align="center" label="展示时间" min-width="90">
                            </el-table-column>
                            <el-table-column prop="image_url" align="center" label="商品图片" min-width="160">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="baseUrl + scope.row.image_url_s" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.image_url;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="origin_price" align="center" label="商品原价" min-width="100">
                            </el-table-column>
                            <el-table-column prop="sale_price" align="center" label="商品售价" min-width="100">
                            </el-table-column>
                            <el-table-column prop="discounts_deduction" align="center" label="立减金额" min-width="100">
                                <template slot-scope="scope">
                                    <span class="c-red">{{scope.row.discounts_deduction}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sort" align="center" label="排序" min-width="90">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="80" fixed="right">
                                <template slot-scope="scope">
                                    <!--<el-button class="option-btn btn-bd-m" type="primary" size="mini" @click="$util.goTo('/goods/goodsdetail',{query:{product_id:scope.row.spu_id}})">商品详情</el-button>-->
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteChannelGoods(scope.row.id)">取消</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export channel-dialog" :title="dlg_goods.title" :visible.sync="dlg_goods.visible" width="800px" @closed="closeChannelGoods" :close-on-click-modal="false">
            <el-form :inline="true" ref="formChannel" :model="dlg_goods.form" label-width="100px" class="demo-form-inline" :rules="dlg_goods.rules" @submit.native.prevent>
                <el-form-item  prop="week" label="推荐时间：" style="margin-bottom: 0;">
                    <el-select size="small" v-model="dlg_goods.form_search.week" placeholder="请选择" @change="getGoodsList">
                        <el-option
                                v-for="item in dlg_goods.init_data.week_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="sort" label="排序：">
                    <el-input size="small" type='number' v-model="dlg_goods.form.sort" placeholder='请输入排序（输入数字）' clearable></el-input>
                </el-form-item>
                <div style="padding: 15px;border: 1px solid #e9e9e9;margin-top: 10px;">
                    <el-form-item prop="name" label="商品名称：" style="margin-bottom: 0;">
                        <el-input v-model="dlg_goods.form_search.name" size="small" placeholder="商品名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="category" label="商品分类：">
                       <!-- <el-select size="small" v-model="dlg_goods.form_search.category_id" filterable @change="getGoodsList" placeholder="请选择">
                            <el-option
                                    v-for="item in dlg_goods.init_data.product_category_list"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>-->

                        <el-cascader
                                :options="dlg_goods.init_data.product_category_list"
                                :props="optionProps"
                                clearable
                                v-model="category_select"
                                expand-trigger="hover"
                                @change="searchCategory"
                                size="small"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item style="margin-bottom: 0;margin-left: 0;">
                        <el-button type="primary" class="search-btn"  size="medium" @click='getGoodsList'>查询</el-button>
                    </el-form-item>
                    <div v-if="dlg_goods.table_data.list.length==0" class="c-wan">*此分类下暂无商品，请选择其他分类</div>
                    <el-table ref="multipleTable" :data="dlg_goods.table_data.list" v-loading="dlg_goods.table_data.loading" max-height="400px" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleGoodsChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                        <el-table-column prop="name" align="center" label="商品名称" min-width="200">
                            <template slot-scope="scope">
                                <my-textEllipsis v-if="is_refresh" :content="scope.row.name"></my-textEllipsis>
                            </template>
                        </el-table-column>
                        <!--<el-table-column prop="product_label" align="center" label="商品标签" min-width="120">
                        </el-table-column>-->
                        <el-table-column prop="image_url" align="center" label="商品图片" min-width="80">
                            <template slot-scope="scope">
                                <img class="cursor" :src="baseUrl + scope.row.image_url" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.image_url;dlg_preview.visible = true;" title="点击查看" />
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div style="padding: 10px 5px 0 5px;" class="c-wan">*请勾选商品推荐到-{{channel_name}}-频道</div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_goods.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitChannelGoods()" :loading="dlg_goods.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog class="dialog-export channel-dialog" :title="dlg_knock.title" :visible.sync="dlg_knock.visible" width="534px" :close-on-click-modal="false">
            <el-form ref="formKnock" :model="dlg_knock.form" label-width="110px" :rules="dlg_knock.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="立减金额：" :error="dlg_knock.error.amount">
                    <el-input size="small" v-model="dlg_knock.form.amount" placeholder='请输入立减金额' clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_knock.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitKnock()" :loading="dlg_knock.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                channel_name:this.$route.query.channel_name == undefined? '' : this.$route.query.channel_name,
                channel_id:this.$route.query.channel_id == undefined? -1 : Number(this.$route.query.channel_id),
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                //搜索
                category_select:[],
                form_search:{
                    channel_id:this.$route.query.channel_id == undefined? -1 : Number(this.$route.query.channel_id),
                    name:"",
                    status: -1,
                    week:0
                },
                optionProps:{
                    value: "id",
                    label: "value",
                    children: "childrens"
                },
                init_data: {
                    status_list: [{id:-1, name: '全部'}],
                    week_list:[]
                },
                baseUrl:this.$client.API_URL,
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_goods:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    form:{
                        sort:'',
                        checkList:[]
                    },
                    error:{
                        name:''
                    },
                    reset_form: {},
                    init_data:{
                        product_category_list: [],
                        week_list:[{id:1, name: '周一'},{id:2, name: '周二'}]
                    },
                    table_data:{
                        loading: false,
                        list:[],
                        page_info: {
                            page: 1,
                            pageSize: 30,
                            total: 130
                        }
                    },
                    rules:{
                        sort:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']},
                        checkList:{required: true, message: '请选择商品', trigger: ['change','blur']}
                    },
                    form_search:{
                        name:'',
                        week:0,
                        category_id:0,
                        channel_id:this.$route.query.channel_id == undefined? -1 : Number(this.$route.query.channel_id)
                    }
                },
                dlg_knock:{
                    visible:false,
                    btn_loading:false,
                    form:{
                        sku_id:'',
                        amount:''
                    },
                    rules:{
                        amount:{required: true, message: '请填写立减金额', trigger: ['change','blur']}
                    },
                    error:{
                        sku_id:''
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = this.channel_name + ' - 商品管理';
            this.dlg_goods.reset_form = Object.assign({}, this.dlg_goods.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_default = [{id:-1, name: '全部'}];
                var category_default = [{id: 0, value: "全部", childrens: [{id: 0, value: "全部"}]}];
                this.$client.get('/adminapi/productchannelsku/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_goods.init_data.week_list = res.week_name_list;
                    _this.init_data.week_list = res.week_name_list;
                    _this.dlg_goods.init_data.product_category_list = category_default.concat(res.product_category_list);
                    //_this.dlg_goods.form_search.category_id = res.product_category_list[0].id;
                    _this.init_data.status_list = status_default.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleGoodsChange(val){
                var mullist = val;
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                this.dlg_goods.form.checkList = idList;
                //console.log(idList);
            },
            searchCategory(val){
                //console.log(val)
                /*this.form_search.category_id = val[0];
                 this.form_search.category_id2 = val[1];*/
                this.dlg_goods.form_search.category_id = val[1];
                this.getGoodsList();
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要取消的商品");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量取消？（取消后商品不再显示在-'+this.channel_name+'-频道内）', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/productchannelsku/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            knockmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要设置立减的商品");
                    return;
                }
                var skuIdList = [];
                for(var i=0;i<mullist.length;i++){
                    skuIdList.push(mullist[i].sku_id);
                }
                this.dlg_knock.form.sku_id = skuIdList.join(",");
                this.dlg_knock.visible = true;
                /*this.$confirm('确定要批量设置立减？（取消后商品不再显示在-'+this.channel_name+'-频道内）', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/productchannelsku/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});*/
            },
            submitKnock(){
                var _this = this;
                this.dlg_knock.btn_loading = true;
                _this.$client.post('/adminapi/productchannelsku/setdeductionamount', _this.dlg_knock.form, function(res,message){
                    _this.getList();
                    _this.dlg_knock.visible = false;
                    _this.dlg_knock.btn_loading = false;
                    _this.dlg_knock.form.sku_id = '';
                    _this.dlg_knock.form.amount = 0;
                },function(res){
                    _this.dlg_knock.btn_loading = false;
                });
            },
            handleChannelGoods(){
                this.dlg_goods.visible = true;
                this.dlg_goods.title =this.channel_name+ ' - 添加推荐商品';
                this.dlg_goods.api = '/adminapi/productchannelsku/save';
                this.getGoodsList();
            },
            deleteChannelGoods(id){
                var _this = this;
                this.$confirm('确定要取消？（取消后商品不再显示在-'+this.channel_name+'-频道内）', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/productchannelsku/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            /*searchCategory(val){
               /!* console.log(val)
                this.dlg_goods.form_search.category_id = val[0];
                this.dlg_goods.form_search.category_id2 = val[1];*!/
                this.getGoodsList();
            },*/
            getGoodsList(){
                var _this = this;
                var params = _this.dlg_goods.form_search;
                this.dlg_goods.table_data.loading=true;
                this.$client.get('/adminapi/productchannelsku/getjoindata', params, function(res,message){
                    _this.dlg_goods.table_data.list = res.list;
                    _this.dlg_goods.table_data.loading=false;
                },function(res){
                    _this.dlg_goods.table_data.loading=false;
                });
            },
            submitChannelGoods(){
                var _this = this;
                _this.$refs['formChannel'].validate((valid) => {
                    if (valid) {
                        this.dlg_goods.btn_loading = true;
                        var params = {
                            channel_id:_this.channel_id,
                            week:_this.dlg_goods.form_search.week,
                            sku_id:_this.dlg_goods.form.checkList.toString(),
                            sort:_this.dlg_goods.form.sort
                        }
                        this.$client.post(this.dlg_goods.api, params, function(res,message){
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_goods.btn_loading = false;
                            _this.dlg_goods.visible = false;
                        }, function(message){
                            _this.dlg_goods.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_goods.error[key] = message[key];
                                }
                            }
                        });
                    }
                })
            },
            closeChannelGoods(){
                for(var key in this.dlg_goods.form){
                    this.dlg_goods.form[key] = this.dlg_goods.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formChannel.clearValidate();
            })
            },

            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .page-channel .el-checkbox-group .el-checkbox__label{
        vertical-align: middle;
    }
    .page-channel .el-upload--picture-card{
        line-height: 80px;
    }
    .page-channel .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
    .page-channel .el-checkbox{
        margin-bottom: 10px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .page-channel .el-checkbox.is-checked .check-content{
        border: 1px solid #3EE0B4;
    }
    .page-channel .channel-dialog .el-dialog{
        margin-top: 25px !important;
    }
    .page-channel .channel-dialog.dialog-export .el-dialog__body{
        padding-bottom: 0;
    }
</style>
<style scoped>
    .check-content{
        width: 120px;
        border: 1px solid #e9e9e9;
        padding: 5px;
        border-radius: 3px;
    }
    .check-content .img-box{
        width: 100%;
        height: 100px;
        overflow: hidden;
    }
    .check-content .img-box img{
        width: 100%;
    }
    .check-content h2{
        font-size: 14px;
        color: #161616;
        font-weight: 600;
        margin: 5px 0;
    }
    .check-content .cost>span{
        display: inline-block;
        width: 50%;
    }
    .check-content .old-cost{
        font-size: 12px;
        color: #666;
        text-decoration:line-through;
    }
    .check-content .new-cost{
        font-size: 16px;
        color: #c23838;
        font-weight: 600;
        text-align: right;
    }
</style>